import * as React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormControl, FormField, FormItem, FormLabel, FormMessage } from '../ui/form'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select'

type Option = { label: string; value: string }

export default function SelectField({ label, name, helpText, placeholder, options, disabled }: { label: string, name: string, helpText?: string, placeholder?: string, options: Option[], disabled?: boolean }) {
    const form = useFormContext()
    return (
        <FormField
            control={form.control}
            name={name}
            render={({ field }) => (
                <FormItem>
                    <FormLabel>{label}</FormLabel>
                    <FormControl>
                        <Select
                            value={field.value}
                            onValueChange={field.onChange}
                            disabled={disabled}
                        >
                            <SelectTrigger>
                                <SelectValue placeholder={placeholder || 'Select…'} />
                            </SelectTrigger>
                            <SelectContent>
                                {options.filter((opt) => {
                                    if (opt.value === '') {
                                        if (import.meta.env.DEV) console.warn('SelectField: option with empty value filtered out — use a sentinel value instead', opt)
                                        return false
                                    }
                                    return true
                                }).map((opt) => (
                                    <SelectItem key={opt.value} value={opt.value}>
                                        {opt.label}
                                    </SelectItem>
                                ))}
                            </SelectContent>
                        </Select>
                    </FormControl>
                    {helpText && <p className='text-sm text-muted-foreground'>{helpText}</p>}
                    <FormMessage />
                </FormItem>
            )}
        />
    )
}


